const mbApprovedNationalAccountIds = new Set(["12"]);

export const isMbApproved = (dealerNationalAccountId: string): boolean =>
  mbApprovedNationalAccountIds.has(dealerNationalAccountId);
